import * as React from "react";

const Icon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="68" height="19" viewBox="0 0 68 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.211914" y="0.433594" width="32.5217" height="18" rx="1" fill="#D9D9D9" />
    <rect x="34.7334" y="0.433594" width="32.5217" height="18" rx="1" fill="#D9D9D9" />
  </svg>
);

export default Icon;
